import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  colors: {
    customGreen: {
      50: "#f2f9f4",
      100: "#d5ecd8",
      200: "#b8e0bb",
      300: "#9cd49f",
      400: "#80c883",
      500: "#8DCF71", // Primary color
      600: "#7BC464", // Hover color
      700: "#6AB056", // Active color
      800: "#4d8041",
      900: "#2f4e29",
    },
    customGray: {
      50: "#F7F8F9", // Very light grey
      100: "#E4E6E7", // Lighter grey
      200: "#DADCDD", // Approaching base
      300: "#D4D6D7", // Slightly lighter than base
      400: "#D1D3D4", // Near base
      500: "#D0D2D3", // Your base color
      600: "#B6B8BA", // Darker grey
      700: "#9EA0A2", // Mid-dark grey
      800: "#6E7071", // Very dark grey
      900: "#3F4041", // Almost black
    },
  },
});

export default theme;
